import { SVGProps } from "react";

export default function ResumeUploadPlusIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#F6F3EF", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.66406 10H13.3307"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.3334V6.66669"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.4974 18.3334H12.4974C16.6641 18.3334 18.3307 16.6667 18.3307 12.5V7.50002C18.3307 3.33335 16.6641 1.66669 12.4974 1.66669H7.4974C3.33073 1.66669 1.66406 3.33335 1.66406 7.50002V12.5C1.66406 16.6667 3.33073 18.3334 7.4974 18.3334Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
